<template>
    <div
        class="md-team broker-float"
        :style="{
            paddingTop,
            marginBottom,
            ...bgStyle
        }"
        v-if="allTotal > 0"
    >
        <module-box
            class="module-box"
            :fullColumn="fullColumn"
            :noPadding="true"
            :noMargin="true"
        >
            <template v-if="!isMobileSize">
                <div class="module-header">
                    <div
                        class="mg-title"
                        v-html="formatFontSize(fmtTitle, '--mg-title-size')"
                    ></div>
                    <div class="arrow" v-if="agents.length > useSlidesPerView">
                        <i class="iconfont icon-arrow-up right next-el"></i>
                        <i class="iconfont icon-arrow-up left prev-el"></i>
                    </div>
                </div>

                <swiper v-bind="options" v-if="agents.length">
                    <slide v-for="(curAgent, index) in agents" :key="index">
                        <div class="img-desc" v-if="curAgent">
                            <div class="desc">
                                <h4 class="desc-title" v-if="curAgent.fullName">
                                    <a
                                        :href="curAgent.detailUrl"
                                        :target="detailUrlTarget"
                                        rel="noopener noreferrer"
                                    >
                                        {{ curAgent.fullName }}
                                    </a>
                                </h4>
                                <div class="position">
                                    <span v-if="curAgent.position">{{
                                        curAgent.position
                                    }}</span>
                                    <span
                                        class="split"
                                        v-if="
                                            curAgent.license &&
                                                curAgent.position
                                        "
                                    >|</span
                                    >
                                    <span v-if="curAgent.license"
                                    >{{ licenseName }}
                                        {{ curAgent.license }}</span
                                    >
                                </div>
                                <div class="info-wrap">
                                    <i
                                        v-if="curAgent.longIntroduction"
                                        class="iconfont icon-quotationmarks"
                                    ></i>
                                    <div
                                        class="info-pc"
                                        v-html="curAgent.longIntroduction"
                                    ></div>
                                </div>

                                <div
                                    class="contact"
                                    :style="{
                                        marginBottom: enableBookAppointment
                                            ? '20px'
                                            : '40px'
                                    }"
                                >
                                    <p class="phone" v-if="curAgent.phone">
                                        <i class="iconfont icon-phone1"></i>
                                        <span
                                        ><a
                                            :href="'tel:' + curAgent.phone"
                                            target="_top"
                                            rel="noopener noreferrer"
                                        >{{
                                            $ft.formatPhone(
                                                curAgent.phone
                                            )
                                        }}</a
                                        ></span
                                        >
                                    </p>
                                    <p class="email" v-if="curAgent.email">
                                        <i class="iconfont icon-v5-email"></i>
                                        <span
                                        ><a
                                            :href="
                                                'mailto:' + curAgent.email
                                            "
                                            rel="noopener noreferrer"
                                        >{{ curAgent.email }}</a
                                        ></span
                                        >
                                    </p>
                                    <p class="address" v-if="curAgent.address">
                                        <i class="iconfont icon-v5-address"></i>
                                        <span>{{ curAgent.address }}</span>
                                    </p>
                                    <p
                                        class="externalUrl"
                                        v-if="curAgent.externalUrl"
                                    >
                                        <i class="iconfont icon-icon-test"></i>
                                        <span
                                        ><a
                                            :href="curAgent.externalUrl"
                                            :target="detailUrlTarget"
                                            rel="noopener noreferrer"
                                        >{{ curAgent.externalUrl }}</a
                                        ></span
                                        >
                                    </p>
                                </div>
                                <Share
                                    v-if="curAgent.agentSocialNetworks"
                                    :socialNetworks="
                                        curAgent.agentSocialNetworks
                                    "
                                />
                                <div class="spacer"></div>
                                <BookAppointment
                                    v-if="enableBookAppointment"
                                    variant="link"
                                    :agent="curAgent"
                                />
                            </div>
                            <a
                                :href="
                                    useExternalUrl
                                        ? curAgent.externalUrl ||
                                            curAgent.detailUrl
                                        : curAgent.detailUrl
                                "
                                :target="detailUrlTarget"
                                rel="noopener noreferrer"
                            >
                                <div class="img-content-float">
                                    <AgentHeadShot :headshots="curAgent.headShots" :initImage="curAgent.image" :alt="agentAlt(curAgent)" keyClass="md-team-broker-float"></AgentHeadShot>
                                </div>
                            </a>
                        </div>
                    </slide>
                </swiper>
            </template>
            <template v-else>
                <div
                    class="mobile-title mg-title"
                    v-if="fmtTitle"
                    v-html="formatFontSize(fmtTitle, '--mg-title-size')"
                ></div>
                <ol class="scroll-wrap">
                    <li v-for="(curAgent, index) in agents" :key="index">
                        <a
                            :href="curAgent.detailUrl"
                            :target="detailUrlTarget"
                            rel="noopener noreferrer"
                        >
                            <AgentHeadShot class="mobile-img" :headshots="curAgent.headShots" :initImage="curAgent.image"></AgentHeadShot>
                        </a>
                        <div class="mobile-info">
                            <div class="desc">
                                <h4 class="desc-title" v-if="curAgent.fullName">
                                    <a
                                        :href="curAgent.detailUrl"
                                        :target="detailUrlTarget"
                                        rel="noopener noreferrer"
                                    >
                                        {{ curAgent.fullName }}
                                    </a>
                                </h4>
                                <div class="position">
                                    <span v-if="curAgent.position">{{
                                        curAgent.position
                                    }}</span>
                                    <span v-if="curAgent.license">{{
                                        curAgent.license
                                    }}</span>
                                </div>
                                <div class="info-wrap">
                                    <i
                                        v-if="curAgent.longIntroduction"
                                        class="iconfont icon-quotationmarks"
                                    ></i>

                                    <viewMore
                                        class="view-more-content info"
                                        v-if="curAgent.longIntroduction"
                                        :line="6"
                                        :content="curAgent.longIntroduction"
                                        :mobileLine="6"
                                    />
                                </div>
                                <div class="contact">
                                    <p class="phone" v-if="curAgent.phone">
                                        <i class="iconfont icon-phone1"></i>
                                        <span
                                        ><a
                                            :href="'tel:' + curAgent.phone"
                                            target="_top"
                                            rel="noopener noreferrer"
                                        ></a
                                        >{{
                                            $ft.formatPhone(curAgent.phone)
                                        }}</span
                                        >
                                    </p>
                                    <p class="email" v-if="curAgent.email">
                                        <i class="iconfont icon-v5-email"></i>
                                        <span
                                        ><a
                                            :href="
                                                'mailto:' + curAgent.email
                                            "
                                            rel="noopener noreferrer"
                                        >{{ curAgent.email }}</a
                                        ></span
                                        >
                                    </p>
                                    <p class="address" v-if="curAgent.address">
                                        <i class="iconfont icon-v5-address"></i>
                                        <span>{{ curAgent.address }}</span>
                                    </p>
                                    <p
                                        class="externalUrl"
                                        v-if="curAgent.externalUrl"
                                    >
                                        <i class="iconfont icon-icon-test"></i>
                                        <span
                                        ><a
                                            :href="curAgent.externalUrl"
                                            :target="detailUrlTarget"
                                            rel="noopener noreferrer"
                                        >{{ curAgent.externalUrl }}</a
                                        ></span
                                        >
                                    </p>
                                </div>
                                <!-- share -->
                                <Share
                                    v-if="curAgent.agentSocialNetworks"
                                    :socialNetworks="
                                        curAgent.agentSocialNetworks
                                    "
                                />
                                <BookAppointment
                                    v-if="enableBookAppointment"
                                    variant="link"
                                    :agent="curAgent"
                                />
                            </div>
                        </div>
                    </li>
                </ol>
            </template>
        </module-box>
    </div>
</template>

<script>
import common from '../index.js';
import { normal } from '../../defaultSpacing';
import Share from './share';
import viewMore from '../../../components/view-more.vue';
import carousel from '../carousel';
import BookAppointment from '../_components/book-appointment.vue';

export default {
    mixins: [common, carousel],
    components: {
        Share,
        viewMore,
        BookAppointment
    },
    data: function() {
        return {
            ...normal,
            disabled: { prev: false, next: false },
            index: 0,
            autoplayDelay: 5,
            slidesPerView: 1,
            mobileSlidesPerView: 1,
            speed: 1000
        };
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-team.broker-float {
    background: #fff;

    @include media-600 {
        padding-bottom: 10px;

        .share-links .sn .iconfont {
            width: 24px;
            height: 24px;
        }
    }

    .module-box {
        overflow: unset !important;
        position: relative;
    }

    .module-header {
        display: flex;
        justify-content: space-between;

        .mg-title {
            font: 24px var(--mg-title-font);
            color: #191919;
            line-height: 1;
        }

        .arrow {
            position: relative;
            top: 4px;
            flex-shrink: 0;
            right: 0;
            z-index: 3;

            &:after {
                display: block;
                content: '';
                clear: both;
            }

            i {
                float: right;
            }

            .left {
                transform: translateX(3px) rotate(-90deg);
                margin-right: 60px;
            }

            .right {
                transform: translateX(-3px) rotate(90deg);
            }

            .iconfont {
                color: #191919;
                font-size: 22px;
                cursor: pointer;

                &.disabled {
                    color: #dadada;
                    cursor: not-allowed;
                }
            }
        }
    }

    .mobile-title > p {
        font: 16px var(--font-bold) !important;
        color: #191919;
        margin-bottom: 15px;
    }

    .img-desc {
        position: relative;
        margin-top: 36px;
        flex: 1;

        .img-content-float {
            width: 50%;
            height: 435px;
            margin-left: 50%;
            margin-top: 24px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 5px;
            }
        }
    }

    .desc {
        position: absolute;
        top: -25px;
        left: 15px;
        width: 60%;
        max-width: 580px;
        padding: 30px;
        border-radius: 5px;
        box-shadow: 0 4px 20px 0 rgba(0, 10, 30, 0.1);
        background-color: #fff;
        z-index: 2;
        min-height: 435px;
        display: flex;
        flex-direction: column;

        @include media-600 {
            position: static;
            width: 100%;
            padding: 15px;
            box-shadow: unset;
            border-radius: 0 0 5px 5px;
        }

        .desc-title {
            font: 18px var(--font-bold);
            color: #191919;
            line-height: 1.39;
            margin-bottom: 5px;
            margin-top: 0;

            @include media-600 {
                font: 14px var(--font-bold);
                line-height: 25px;
                margin-bottom: 2px;
            }
        }

        .position {
            span {
                font: 12px var(--font-normal);
                color: #505050;
            }
        }

        .info-wrap {
            margin-top: 17px;
            margin-bottom: 30px;
            // height: 100px;
            position: relative;
            z-index: 1;

            // @include media-600 {
            //     height: 150px;
            //     margin: 15px 0;
            // }
            .info-pc {
                font: 14px var(--font-medium);
                font-style: italic;
                color: #3c3c3c;
                line-height: 25px;
                overflow: auto;
                height: 83px;
            }

            .info {
                font: 14px var(--font-medium);
                font-style: italic;
                color: #3c3c3c;
                line-height: 25px;

                // @include webkitBox(4);
                @include media-600 {
                    font-size: 12px;
                    font-style: italic;
                    // @include webkitBox(6);
                }
            }

            .view-more-content {
                &:last-of-type {
                    padding-bottom: 0;
                }
            }

            .iconfont {
                position: absolute;
                left: 0;
                top: -7px;
                color: rgba(218, 218, 218, 0.8);
                font-size: 24px;
                z-index: -1;
            }
        }

        .contact {
            margin-bottom: 20px;
            @include media-600 {
                margin-bottom: 15px;
            }

            > p {
                display: flex;
                flex-direction: row;
                font: 12px var(--font-normal);
                color: #505050;
                margin-bottom: 8px;
                .iconfont {
                    margin-right: 8px;
                    width: 14px;
                    height: 14px;
                    display: flex;
                    flex-direction: row;
                    align-content: center;
                    justify-content: center;
                    font-size: 14px;

                    &.icon-v5-email {
                        transform: scale(0.7);
                    }
                }
            }
        }

        .spacer {
            flex-grow: 1;
        }
    }

    .scroll-wrap {
        overflow-y: hidden;
        overflow-x: auto;
        display: flex;
        flex-wrap: nowrap;
        background: #fff;
        padding: 0 15px 10px;
        margin-left: -15px;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }

        li {
            flex-shrink: 0;
            width: 320px;
            // height: 672px;
            overflow: hidden;
            border-radius: 5px;
            margin-right: 16px;
            box-shadow: 0 4px 20px 0 rgba(0, 10, 30, 0.1);
            background-color: #fff;

            &:last-child {
                margin-right: 0;
            }

            .mobile-img {
                width: 320px !important;
                height: 280px !important;
                object-fit: cover;
            }
        }
    }
}
</style>
